import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import { GET_ITENS_MENU } from "./actionType";

import { menuApiResponseSuccess, menuApiResponseError } from "./action";

import { getMenuItens } from "../../helpers/backend_helper";

function* getItensMenu() {
  try {
    const response = yield call(getMenuItens);
    yield put(menuApiResponseSuccess(GET_ITENS_MENU, response));
  } catch (error) {
    yield put(menuApiResponseError(GET_ITENS_MENU, error));
  }
}

export function* watchGetItensMenu() {
  yield takeEvery(GET_ITENS_MENU, getItensMenu);
}

function* menuSaga() {
  yield all([fork(watchGetItensMenu)]);
}

export default menuSaga;
